export const RESIZE = 'RESIZE'
export const SCROLL = 'SCROLL'
export const PAGE_INIT = 'PAGE_INIT'
export const HASH_CHANGE = 'HASH_CHANGE'